
(function ($) {
    $(document).ready(function () {
        $('.ua-ie body .related-articles').addClass("cl-ie");
        $('.related-articles .col-wrapper .content-wrapper').matchHeight();
    });

})(jQuery);
